import React, { useState } from 'react'
import styles from './BaseAccordion.module.css'

export const BaseAccordion = ({ items }) => {
    const [openIndex, setOpenIndex] = useState(null)

    const toggle = (index) => {
        setOpenIndex(openIndex === index ? null : index)
    }

    return (
        <div className={styles.accordion}>
            {items.map((item, index) => (
                <div
                    key={index}
                    className={`${styles.accordionItem} ${openIndex === index ? styles.isOpen : ''}`}
                    onClick={() => toggle(index)}
                >
                    <div className={styles.accordionHeader}>
                        <span className={styles.itemTitle}>{item.question}</span>
                        <span className={`${styles.chevron} ${openIndex === index ? styles.rotated : ''}`}>▼</span>
                    </div>
                    {openIndex === index && (
                        <div className={styles.accordionContent}>
                            <div dangerouslySetInnerHTML={{ __html: item.answer }} />
                        </div>
                    )}
                </div>
            ))}
        </div>
    )
}

export default BaseAccordion
